import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../../i18n';
import { cameraIcon, DownloadIconComponent } from '../../../../../assets';
import { formatCoursePrice } from '../../../../../utilities';
import './styles.scss';

const AnyCourse = ({ courses, lessonsCount, oldPrice, className }) => (
  <div className={classNames('any-course', className)}>
    <h2 className="any-course__title"> {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.POSSIBLE_COURSE')}</h2>
    <div className="any-course__courses">
      {courses.map(c => (
        <img className="any-course__course-picture" key={c.title} src={c.imageUrl} alt={c.title} title={c.title} />
      ))}
    </div>
    <div className="any-course__subtitle">
      <b>{t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.POSSIBLE_COURSE_WITH_TRAINER')}</b>
    </div>
    <div className="any-course__summary">
      <div className="any-course__course-lessons-number">
        <img src={cameraIcon} alt="lessons-number" />
        {`${lessonsCount} ${t('DIGITAL_COURSES.LESSONS')}`}
      </div>
      <div>
        <DownloadIconComponent />
        {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.MATERIALS')}
      </div>
      <div className="any-course__course-price">
        <span className="any-course__course-price-text any-course__course-price-text--new">
          {formatCoursePrice({ amount: 0, currency: oldPrice.currency })}
        </span>
        <span className="any-course__course-price-text any-course__course-price-text--old">
          {formatCoursePrice(oldPrice)}
        </span>
      </div>
    </div>
  </div>
);

AnyCourse.Placeholder = ({ className }) => (
  <div className={classNames('any-course__placeholder', 'placeholder-glow', className)}>
    <div className="placeholder" />
  </div>
);

AnyCourse.Card = ({ className }) => <div className={classNames('any-course', className)} />;

export default AnyCourse;
